import { css } from "@microsoft/fast-element";
import { display } from "@fluentui/web-components";
import { sizeHorizontalXL } from "@fabric-msft/theme";
export const styles = css `
  ${display("inline-flex")}

  :host,
  :host svg {
    height: var(--icon-height, ${sizeHorizontalXL});
    width: var(--icon-width, ${sizeHorizontalXL});
  }

  :host svg:not([role="img"]) {
    fill: currentcolor;
  }
`;
//# sourceMappingURL=svg-icon.styles.js.map